import { InputAdornment, Input } from "@mui/material";
import PropTypes from "prop-types";

import SiteIcons from "@/components/SiteIcons/SiteIcons";

import "@/components/SearchBar/SearchBar.css";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  return (
    <Input
      id="table-search-bar"
      className="searchBar"
      onChange={(e) => setSearchTerm(e.target.value)}
      value={searchTerm}
      placeholder="Search"
      endAdornment={
        <InputAdornment position="end">
          <SiteIcons iconstring="search" />
        </InputAdornment>
      }
    />
  );
};

SearchBar.propTypes = {
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  width: PropTypes.string,
  justifyContent: PropTypes.string,
};

export default SearchBar;
